export type CommunicationType = 'T' | 'M';

export enum COMMUNICATION_TYPE {
    TELEFONO = 'T',
    MAIL = 'M'
}